export const CART_UPDATED_EVENT = 'MIELE_CART_UPDATED';
